export default __webpack_public_path__ + "static/media/logo.ec00446b.png";